import React from "react";

export default React.memo(function Required(props) {
    if (props.required === true) {
        return <span className="required oi oi-star mr-1"></span>
    } else {
        return <span className="required-conditional oi oi-star mr-1"></span>
    }
});